export default "__VITE_ASSET__FpJpXzc5__"